
/* injects from baggage-loader */
var Template = require('./template.js');
require('./style.scss');

import { Component } from 'react';
import { connect } from "react-redux";
import moment from "moment";
import { SetMultipleDaysReport, SetTodaysReport } from "../../../actions/terminal";
import PropTypes from "prop-types";
import { UIMixin } from "../../../mixins/uiMixin";
import Config from '../../../config/main';

class TodaysReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date()
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleClickTodaysReport = this.handleClickTodaysReport.bind(this);
        this.handleChangeEndDate = this.handleChangeEndDate.bind(this);
    }

    handleChange(date) {
        this.setState({
            startDate: moment(date).toDate(),
        });
    }
    handleChangeEndDate(date) {
        this.setState({
            endDate: moment(date).toDate(),
        })
    }
    
    handleClickTodaysReport() {
        if (Config.enableMultipleDaysReport) {
            const dateRange = {
                start : this.state.startDate && moment(this.state.startDate).format("DD-MM-YYYY"),
                end: this.state.endDate && moment(this.state.endDate).format("DD-MM-YYYY"),
            };
            return () => {
                this.props.dispatch(SetMultipleDaysReport(dateRange))
                this.props.closePopup()();
            };
        }
        return () => {
            this.props.dispatch(SetTodaysReport(moment(this.state.startDate).format("DD-MM-YYYY")));
            this.props.closePopup()();
        }
    }
    render() {
        return Template.default.apply(this); //eslint-disable-line no-undef
    }
}

TodaysReport.propsTypes = {
    data: PropTypes.string,
    currency: PropTypes.string,
    closePopup: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        currency: state.user.currency
    };
};

export default connect(mapStateToProps)(UIMixin({ Component: TodaysReport }));